import { formatMajorMoney } from '@eventbrite/intl';

interface PartialTicketCost {
    currency: string;
    currencyFormat: string | null;
    value: number;
}

export const getUndiscountedBOGOTicketPrice = ({
    currency,
    currencyFormat,
    value,
}: PartialTicketCost) => {
    return formatMajorMoney(value * 2, currency, currencyFormat);
};
